import { render, staticRenderFns } from "./tdColUUID.vue?vue&type=template&id=2222826f&"
import script from "./tdColUUID.vue?vue&type=script&lang=js&"
export * from "./tdColUUID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports